/* tslint:disable */

declare var Object: any;
export interface VolumeDiscountRateRequestInterface {
  "partnerId": string;
  "productType": string;
  "merchantType": number;
  "paymentType": number;
  "discount": number;
  "unit": string;
  "minimum": number;
  "dateCreated": Date;
  "lastUpdated": Date;
  "requestor": number;
  "id"?: number;
  user?: any;
}

export class VolumeDiscountRateRequest implements VolumeDiscountRateRequestInterface {
  "partnerId": string;
  "productType": string;
  "merchantType": number;
  "paymentType": number;
  "discount": number;
  "unit": string;
  "minimum": number;
  "dateCreated": Date;
  "lastUpdated": Date;
  "requestor": number;
  "id": number;
  user: any;
  constructor(data?: VolumeDiscountRateRequestInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `VolumeDiscountRateRequest`.
   */
  public static getModelName() {
    return "VolumeDiscountRateRequest";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of VolumeDiscountRateRequest for dynamic purposes.
  **/
  public static factory(data: VolumeDiscountRateRequestInterface): VolumeDiscountRateRequest{
    return new VolumeDiscountRateRequest(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'VolumeDiscountRateRequest',
      plural: 'VolumeDiscountRateRequests',
      path: 'VolumeDiscountRateRequests',
      idName: 'id',
      properties: {
        "partnerId": {
          name: 'partnerId',
          type: 'string'
        },
        "productType": {
          name: 'productType',
          type: 'string'
        },
        "merchantType": {
          name: 'merchantType',
          type: 'number'
        },
        "paymentType": {
          name: 'paymentType',
          type: 'number'
        },
        "discount": {
          name: 'discount',
          type: 'number',
          default: 0
        },
        "unit": {
          name: 'unit',
          type: 'string',
          default: 'P'
        },
        "minimum": {
          name: 'minimum',
          type: 'number',
          default: 0
        },
        "dateCreated": {
          name: 'dateCreated',
          type: 'Date'
        },
        "lastUpdated": {
          name: 'lastUpdated',
          type: 'Date'
        },
        "requestor": {
          name: 'requestor',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        user: {
          name: 'user',
          type: 'any',
          model: '',
          relationType: 'belongsTo',
                  keyFrom: 'requestor',
          keyTo: 'id'
        },
      }
    }
  }
}
